"use strict";

exports.__esModule = true;
exports["default"] = createBasenameMiddleware;

var _createLocationMiddleware = _interopRequireDefault(require("./createLocationMiddleware"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function createBasenameMiddleware(_ref) {
  var basename = _ref.basename;

  if (!basename || basename === '/') {
    // Fast path in case basename is trivial.
    return function () {
      return function (next) {
        return next;
      };
    };
  } // Normalize away trailing slash on basename.


  var pathnamePrefix = basename.slice(-1) === '/' ? basename.slice(0, -1) : basename;
  return (0, _createLocationMiddleware["default"])({
    makeLocationDescriptor: function makeLocationDescriptor(location) {
      return _extends({}, location, {
        pathname: "" + pathnamePrefix + location.pathname
      });
    },
    makeLocation: function makeLocation(location) {
      return _extends({}, location, {
        pathname: location.pathname.indexOf(pathnamePrefix) === 0 ? location.pathname.slice(pathnamePrefix.length) : null
      });
    }
  });
}

module.exports = exports.default;